const getTableActionIntro = () => {
    return `
        const TableAction = (props) => {
        const { enableBulkActions, selectedCounter, handleRemoveAction, activeTab, isDocumentsList,
            handleGetFile, selectedDocument, enableClone, handleCloneAction, enableRemove, enableArchived, handleArchivedAction, customActions } = props;
        };
        export default TableAction;
    `;
}

export default getTableActionIntro;
